import { DraftService } from './../../services/draft.service';
import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { DraftPick, GameObject } from 'app/models/draft';
import { TurnDialogComponent } from 'app/modules/draft/dialogs/turn-dialog-container/turn-dialog-container.component';
import { MdTabNavigationComponent } from 'app/modules/md-tab-navigation/md-tab-navigation.component';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';
import { UIService } from 'shared/services/UI/ui.service';
import { UserService } from 'shared/services/User/user.service';


@Component({
  selector: 'app-draft',
  templateUrl: './draft.component.html',
  styleUrls: ['./draft.component.css']
})

export class DraftComponent implements OnInit, OnDestroy {
  groupId;
  _TIME_DISPLAY: string;
  _STATUS_CODE: number;
  _STATUS_TEXT: string;
  _DRAFT_PICKS: any = [];
  SELECTED_TAB_INDEX;
  _ROUND_NUMBER: string;
  imgHandle = environment.URL_TEAM_IMAGES;
  resultsToggled: Boolean = false;
  activateDoneButton: Boolean = false;
  canViewResults: Boolean = false;
  completed: Boolean = false;
  searchQueuedGames = new EventEmitter();
  queueSearchQuery: string;
  loading: boolean;
  isShowPopup: Boolean = true;
  isTrunPopup: Boolean = true;
  queueGameSubscription;

  draftPickSub;
  timerEventSub;
  currentTabSub;
  pickTicketSubscription;
  turnSubscription;
  errorSub;
  isShowErrorAlert: Boolean = true;

  // temp
  drafting;
  notDisplaying;
  queueing;

  completedSubscription: any;
  _GAMES: GameObject[];

  constructor(
    private draftService: DraftService,
    public snackBar: MatSnackBar,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private nav: MdTabNavigationComponent,
    private userService: UserService,
    private ui: UIService) {
    // loader on
    this.loading = true;
    this.route.queryParams.subscribe(params => { this.groupId = params.group_id; });
    this.draftPickSub = this.draftService.draftPickSubscription$.subscribe(draftPiks => {
      this._DRAFT_PICKS = draftPiks;
      if (this._DRAFT_PICKS[0] !== undefined) {
        this._ROUND_NUMBER = this._DRAFT_PICKS[0].round_number;
      }
    });

    this.queueGameSubscription = this.draftService.queueGameList$.subscribe(games => {
      this._GAMES = games;
    });

    this.pickTicketSubscription = this.draftService.pickedTicketSubscription$.subscribe(pickedTicketData => {
      const index: any = this._GAMES.findIndex((oneGame) => {
        return oneGame.game_id === pickedTicketData.game_id;
      });

      this._GAMES[index]['picked'] = true;
      this._GAMES[index]['chooser'] = pickedTicketData.name;
      this._GAMES[index]['chooser_img'] = pickedTicketData.thumb_img;

      setTimeout(() => {
        this._GAMES[index]['fadeOut'] = true;
      }, 1500);

      const message = pickedTicketData.name + ' selected ' + this._GAMES[index].team_city + ' ' + this._GAMES[index].team_name;
      this.snackBar.open(message, 'Dismiss', {
        duration: 3000,
        panelClass: 'draft-pick-bar'
      });
    });

    this.completedSubscription = this.draftService.draftCompletedSubscription$.subscribe(completed => {
      if (completed) {
        this.canViewResults = true;
        this.completed = true;
        setTimeout(() => {
          this.loading = false;
          this.SELECTED_TAB_INDEX = 2;
        }, 1600);
      }
    });

    this.turnSubscription = this.draftService.myTurnSubscription$.subscribe(yourTurn => {
      if (this.isTrunPopup) {
        this.isTrunPopup = false;
        const draftDialogRef = this.dialog.open(TurnDialogComponent, {
          width: '500px',
          data: { games: this.draftService.AVAILABLE_GAMES, timer: this.draftService.timerEvent$, count: this.draftService._COUNTDOWN }
        });
        draftDialogRef.afterClosed().subscribe(result => {
          setTimeout(() => {
            this.isTrunPopup = true;
          }, 2000);
        });
        const sub = draftDialogRef.componentInstance.draftGameEmitter.subscribe((game) => {
          this.draftService.draftGame(game);
        });
      }
    });

    this.updateStatus(this.draftService._TIMER_EVENT_STATUS);
    this.timerEventSub = this.draftService.timerEvent$.subscribe(time => {
      this.loading = false;
      this.updateStatus(time);
      if (time.status === 'QUEUE') {
        if (this.isShowPopup) {
          this.isShowPopup = false;
          this.getReady();
        }
      } else if (time.status === 'COMPLETE') {
        this.loading = false;
        this.canViewResults = true;
        this.SELECTED_TAB_INDEX = 2;
      } else {
        this.canViewResults = true;
      }
    });

    this.errorSub = this.draftService.error$.subscribe(msg => {
      console.error('An error occured during the draft');
      switch (msg) {
        case 'TIMEOUT':
          if (this.draftService.DRAFT_STATUS !== 'COMPLETE') {
            this.showErrorAlert();
          }
          return;
        case 'FORCE':
          console.error('Forcing refresh...');
          this.draftService.stopDraftPickUpdatePoller();
          // this.reconnectDraft();
          return;
        default:
          return;
      }
    });
  }

  ngOnInit() {
    this.nav.pageName = 'DRAFT';
    this.joinDraft();
  }

  joinDraft() {
    this.draftService.componentJoinedDraft(this.groupId).then(draftPicks => {
      this.draftService.startDraft();
      this.draftService.updateYourResults();
    });
  }

  userSearchingQueueGames(event) {
    // Handle spacecs
    if (event.code === 'Space') {
      this.queueSearchQuery = this.queueSearchQuery + ' ';
    } else {
    }
    this.searchQueuedGames.emit(this.queueSearchQuery);
  }

  updateStatus(time) {
    if (time.countdown === 0) {
      this.updateExpiredStatus(time);
    } else {
      this.updateRoundNumber(time);
    }
  }

  updateRoundNumber(data) {
    switch (data.status) {
      case 'QUEUE':
        this._STATUS_CODE = 0;
        this._STATUS_TEXT = 'Queue: ';
        break;
      case 'DRAFT PICK IN':
        this._STATUS_CODE = 1;
        this._STATUS_TEXT = 'Draft Pick In: ';
        this._ROUND_NUMBER = data.round;
        break;
      case 'COMPLETE':
        this._STATUS_CODE = 2;
        this._STATUS_TEXT = 'Draft Completed!';
        this._ROUND_NUMBER = '';
        this.doneWithDraft();
        break;
      default:
        this._ROUND_NUMBER = '';
        this._STATUS_CODE = 1;
        /* this._STATUS_TEXT = data.status; */
        break;
    }
    this._TIME_DISPLAY = data.countdown.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
  }

  updateExpiredStatus(time) {
    switch (time.status) {
      case 'QUEUE':
        this._STATUS_TEXT = 'Queue Complete';
        this._TIME_DISPLAY = '';
        setTimeout(() => {
          this._STATUS_TEXT = 'Waiting For Draft To Start';
        }, 1500);
        break;
      case 'DRAFT PICK IN':
        this._STATUS_TEXT = 'Draft Pick Completed';
        this._TIME_DISPLAY = '';
        break;
      case 'COMPLETE':
        this._STATUS_CODE = 2;
        this._STATUS_TEXT = 'Draft Completed!';
        this._ROUND_NUMBER = '';
        break;
    }
  }

  getInitial(firstName, lastName) {
    return firstName.charAt(0) + lastName.charAt(0);
  }

  goTicketsHome() {
    this.router.navigate(['/groups/get-ready'], { queryParams: { groupId: this.groupId } });
  }

  ngOnDestroy() {
    // alert('DESTROY');
    this.timerEventSub.unsubscribe();
    this.draftPickSub.unsubscribe();
    this.pickTicketSubscription.unsubscribe();
    this.turnSubscription.unsubscribe();
    this.draftService.stopDraftPickUpdatePoller();
    this.draftService.resetTimerEvent();
    this.isShowErrorAlert = false;
  }

  showErrorAlert() {
    this.loading = false;
    if (this.isShowErrorAlert) {
      Swal.fire({
        title: 'FOUL !',
        type: 'warning',
        text: 'Something went wrong. Please reconnect the draft.',
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Reconnect Draft',
        cancelButtonText: 'Go Home'
      }).then((result) => {
        if (result.value) {
          this.draftService.stopDraftPickUpdatePoller();
          location.reload();
        } else {
          this.router.navigate(['/groups']);
        }
      });
    }
  }


  getReady() {
    this.loading = false;
    Swal.fire({
      title: 'GET READY',
      type: 'success',
      text: 'Your draft will begin shortly. Use this time to queue up your desired games.',
      showCancelButton: true,
      allowOutsideClick: false,
      timer: 3500,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Okay',
    }).then((result) => {
    });
  }

  doneWithDraft() {
    const gameCount = this.draftService.myResultsArray.length;
    const TOTAL_DUE: Number = this.getTotal(this.draftService.myResultsArray);
    const newTotal = ((+TOTAL_DUE + +.30) / .971).toFixed(2);
    const otherGamesCount = Number(this.draftService.CURRENT_GROUP.group_draft_picks.length) - gameCount;
    let doneMessage;
    if (this.draftService.CURRENT_GROUP.type === 'UPLOAD') {
      if (this.userService.user.uid === this.draftService.CURRENT_GROUP.leader_uid) {
        // Group leader upload
        // tslint:disable-next-line:max-line-length
        doneMessage = 'Congratulations! You selected' + gameCount + 'games and' + otherGamesCount +
          'games will be automatically transferred to your group members Team Account. Please allow 48 hours to recieve payment for your games.';
      } else {
        // Non GL upload
        if (this.draftService.CURRENT_GROUP.max_preauth === 0) {
          // payment disabled
          doneMessage = 'Congratulations! You won ' + gameCount +
            ' games. Please allow 48 hours for tickets to appear in your team account. ';
        } else {
          // tslint:disable-next-line:max-line-length
          doneMessage = 'Congratulations! You won ' + gameCount + ' games. You will be charged: $' + newTotal + ' Please allow 48 hours for tickets to appear in your team account. ';
        }
      }
    } else {
      // tslint:disable-next-line:max-line-length
      doneMessage = 'Congratulations! You won ' + gameCount + ' games. You will be charged: $' + newTotal + ' Please allow 48 hours for tickets to appear in your team account. ';
    }
    Swal.fire({
      title: 'Ticket Draft Complete',
      type: 'success',
      text: doneMessage,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Leave Draft Room',
    }).then((result) => {
      if (result.value) {
        this.router.navigate(['/groups']);
      }
    });
  }

  getTotal(results): Number {
    let sum = 0;
    results.forEach(game => {
      sum += Number(game.face_value);
    });
    return Number(sum.toFixed(2));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/draft/components/draft/draft.component.ts